import { useQuery } from 'react-query';
import { Header } from 'semantic-ui-react';
import { getDealExclusionsForListing } from '~/api/dealExclusions';
import { Table } from '~/components';
import { usePermissions } from '~/requests/permissions/usePermissions';

type Props = {
  projectId?: string;
  portfolioId?: string;
};

export default function ListingDealExclusionsTable({
  projectId,
  portfolioId
}: Props) {
  const { permissions } = usePermissions();
  const { data, isLoading, isError } = useQuery(
    ['deal-exclusions-listing', projectId ?? '', portfolioId ?? ''],
    () => getDealExclusionsForListing({ projectId, portfolioId }),
    { enabled: Boolean(projectId || portfolioId) }
  );

  const rows = data?.exclusions ?? [];
  const canViewReasons = Boolean(permissions?.isAdmin);

  if (!isLoading && !isError && rows.length === 0) {
    return null;
  }

  return (
    <div style={{ marginTop: '40px', paddingTop: '24px', borderTop: '1px solid #e8e8e8' }}>
      <Header as="h3" style={{ marginBottom: '8px' }}>
        Excluded companies
      </Header>
      <p style={{ color: '#666', fontSize: '14px', marginBottom: '16px', maxWidth: '720px' }}>
        Buyers listed here are excluded from seeing this deal.
      </p>

      {isLoading ? (
        <p style={{ color: '#666' }}>Loading exclusions…</p>
      ) : isError ? (
        <p style={{ color: '#a00' }}>Could not load exclusions.</p>
      ) : (
        <div className="summary-table-container">
          <Table compact collapsing>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell color="grey">Company</Table.HeaderCell>
                {canViewReasons ? <Table.HeaderCell color="grey">Reason</Table.HeaderCell> : null}
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {rows.map((row: any) => (
                <Table.Row key={row.id}>
                  <Table.Cell>{row.company?.name || '—'}</Table.Cell>
                  {canViewReasons ? (
                    <Table.Cell>{row.reason?.trim() ? row.reason : '—'}</Table.Cell>
                  ) : null}
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </div>
      )}
    </div>
  );
}
